export default __webpack_public_path__ + "static/media/miguel-lopes-18.3f368ae9.jpg";